import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { authAPI } from '../services/api';
import './Login.css';

const Activate = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const navigate = useNavigate();

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password.length < 6) { setError('Şifre en az 6 karakter olmalı'); return; }
    if (password !== confirmPassword) { setError('Şifreler eşleşmiyor'); return; }
    if (!token) { setError('Geçersiz aktivasyon bağlantısı'); return; }

    setLoading(true);
    try {
      const res = await authAPI.activate({ token, password, confirmPassword });
      setSuccess(res.data.message);
      setTimeout(() => navigate('/login'), 2500);
    } catch (err) {
      setError(err.response?.data?.error || err.response?.data?.errors?.[0]?.msg || 'Aktivasyon başarısız');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-left">
        <div className="login-brand">
          <img src="/mtu-hub-2026-light.png" alt="MTU Agent HUB" className="login-logo-img" />
          <p className="login-welcome">Hesabınızı aktifleştirin ve şifrenizi belirleyin.</p>
        </div>
        <div className="login-footer-left">
          <img src="/mtu-2025-wht.png" alt="MTU Corporate Travel" className="login-footer-logo" />
          <span className="login-footer-text">&copy; {new Date().getFullYear()} MTU Corporate Travel</span>
        </div>
      </div>
      <div className="login-right">
        {success ? (
          <div className="login-form" style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 48, marginBottom: 16, color: 'var(--success-600)' }}>✓</div>
            <h3 className="login-title success">Hesap Aktifleştirildi</h3>
            <p className="login-desc">{success}</p>
            <p className="login-hint">Giriş sayfasına yönlendiriliyorsunuz...</p>
          </div>
        ) : (
          <form className="login-form" onSubmit={handleSubmit}>
            <h3 className="login-title">Hesap Aktivasyonu</h3>
            <p className="login-desc">Hesabınız oluşturuldu. Devam etmek için bir şifre belirleyin.</p>
            {error && <div className="login-error">{error}</div>}
            {!token && (
              <div className="login-error">Geçersiz aktivasyon bağlantısı. Lütfen yöneticinizden yeni bir bağlantı isteyin.</div>
            )}
            <div className="form-group">
              <label className="form-label">Yeni Şifre</label>
              <input type="password" className="form-input" value={password} onChange={e => setPassword(e.target.value)} placeholder="En az 6 karakter" required minLength={6} autoFocus disabled={!token} />
            </div>
            <div className="form-group">
              <label className="form-label">Şifre Tekrar</label>
              <input type="password" className="form-input" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} placeholder="Şifrenizi tekrar girin" required minLength={6} disabled={!token} />
              {confirmPassword && password !== confirmPassword && (
                <span className="login-field-error">Şifreler eşleşmiyor</span>
              )}
            </div>
            <button type="submit" className="btn btn-primary login-btn" disabled={loading || !token || password.length < 6 || password !== confirmPassword}>
              {loading ? 'Aktifleştiriliyor...' : 'Hesabı Aktifleştir'}
            </button>
            <div style={{ textAlign: 'center', marginTop: 16 }}>
              <button type="button" onClick={() => navigate('/login')} className="login-link-btn muted">
                ← Giriş sayfasına dön
              </button>
            </div>
          </form>
        )}
        <p className="login-footer">MTU Corporate Travel &copy; {new Date().getFullYear()}</p>
      </div>
    </div>
  );
};

export default Activate;
